import { atom } from "jotai";
import { BookviewPanelStatus } from "models/enumerations/bookview-panel-status";

const BookviewPanelStatusAtom = atom<BookviewPanelStatus | null>(
    BookviewPanelStatus.None
);

export default BookviewPanelStatusAtom;
